enum PerformersType {
  All = 0,
  TopFive = 1,
  BottomFive = 2,
}

export default PerformersType;
